import { render, staticRenderFns } from "./PaymentPricingWrapper.vue?vue&type=template&id=789241ec&"
import script from "./PaymentPricingWrapper.vue?vue&type=script&lang=js&"
export * from "./PaymentPricingWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports